const state = {
  alertsCount: 0,
  alerts: [],
}

const getters = {
  alertsCount: (state) => state.alertsCount,
  alerts: (state) => state.alerts,
}
const actions = {
  FETCH_LAST_ALERTS: async ({ commit, rootGetters }, kuzzle) => {
    if (!rootGetters['auth/currentIndex']) {
      return
    }

    try {
      const twentyFourHoursAgoTimestamp = Math.floor(
        (Date.now() - 24 * 60 * 60 * 1000) / 1000,
      )
      const searchQuery = {
        query: {
          range: {
            timestamp: {
              gte: twentyFourHoursAgoTimestamp,
              lte: Math.floor(Date.now() / 1000),
            },
          },
        },
        sort: [{ timestamp: 'desc' }],
      }

      const searchResult = await kuzzle.document.search(
        rootGetters['auth/currentIndex'],
        'alerts',
        searchQuery,
      )
      const alertsCount = searchResult.total

      const alerts = searchResult.hits.map((alert) => {
        return {
          id: alert._id,
          alertType: alert._source.alertType,
          tagId: alert._source.tagId,
          idAsset: alert._source.idAsset,
          timestamp: alert._source.timestamp,
        }
      })

      commit('SET_ALERTS_COUNT', alertsCount)
      commit('SET_ALERTS', alerts)
    } catch (error) {
      console.log(error)
      throw error
    }
  },
}
const mutations = {
  SET_ALERTS_COUNT(state, alertsCount) {
    state.alertsCount = alertsCount
  },
  SET_ALERTS(state, alerts) {
    state.alerts = alerts
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
